import { Dispatch, ReactNode, SetStateAction, createContext, useState } from 'react'

type DefexProviderProps = {
	children: ReactNode
}

type DefexContextData = {
	selectedTags: any[]
	setSelectedTags: Dispatch<SetStateAction<object[]>>
}

const DefexContext = createContext({} as DefexContextData)

const DefexProvider = ({ children }: DefexProviderProps) => {
	const [selectedTags, setSelectedTags] = useState<object[]>([{}])

	return (
		<DefexContext.Provider
			value={{
				selectedTags,
				setSelectedTags
			}}
		>
			{children}
		</DefexContext.Provider>
	)
}

export { DefexProvider, DefexContext }
